export class PstTaxQueryParameters {
  embed?: any;
  endDate?: Date;
  id?: string;
  onGst?: string;
  page?: number;
  pageSize?: number;
  pstPercent?: number;
  provinceId?: string;
  rooftopId?: string;
  startDate?: Date;

  constructor(obj?: PstTaxQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
